import * as React from "react";

const EditSvg = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        fill="none"
        viewBox="0 0 24 24"
    >
        <path
            d="M2.667 21.333h1.9L17.6 8.3l-1.9-1.9L2.667 19.433zM0 24v-5.667L17.6.767Q18 .4 18.483.2 18.967 0 19.5 0q.534 0 1.033.2.501.2.867.6l1.833 1.867q.4.366.584.866t.183 1q0 .534-.183 1.017a2.5 2.5 0 0 1-.584.883L5.667 24zM16.633 7.367 15.7 6.4l1.9 1.9z"
        ></path>
    </svg>
);

export default EditSvg;
